function RequestHeader() {
  return (
    <>
      <div className="request__header">
        <div>Αριθμος Ονομαστικου</div>
        <div>Ονομασια</div>
        <div>Κυριο Υλικο</div>
        <div>Αιτουμενη Ποσοτητα</div>
        <div>MM</div>
        <div>Αιτολογια</div>
        <div>Προτεραιοτητα</div>
        <div>Καρτελα</div>
        <div></div>
        <div className="grid-border-line"></div>
      </div>
    </>
  );
}

export default RequestHeader;
